import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { RoutePaths } from 'src/core/router/RoutePaths';
import LogoImage from 'src/icons/logo.svg';
import { ThemeStore } from 'src/stores/ThemeStore/ThemeStore';
import styled from 'styled-components';

const StyledWrapper = styled(Link)`
    color: #0d0f1c;
    display: flex;
    margin-right: 130px;

    &:hover {
        text-decoration: none;
        color: #0d0f1c;
    }
`;

export const Logo = observer(() => {
    return (
        <StyledWrapper to={RoutePaths.index}>
            <StyledImage maxWidth={ThemeStore.getLogoMaxSize} src={LogoImage} />
        </StyledWrapper>
    );
});

const StyledImage = styled.img<{ maxWidth?: string }>`
    max-width: ${(props) => props.maxWidth};
`;
